module.exports = __webpack_public_path__ + "img//DIGECO_03_03_02.svg";